import { Theme } from '../Theme'

const RESOURCE_TYPES = [
  'block',
  'view',
  'board',
  'story',
  'moment',
  'content',
] as const
type ResourceTypes = (typeof RESOURCE_TYPES)[number]
type GlyphVariants = 'filled' | 'outlined'

const storyfirstVariants = {
  outlined: '-outlined',
  filled: { light: '-filled-light', dark: '-filled-dark' },
}

const resourceGlyphMap = {
  block: ['gem-block', storyfirstVariants],
  view: ['gem-plans', { outlined: '' }],
  board: ['gem-grid', { outlined: '' }],
  content: ['gem-content', storyfirstVariants],
  moment: ['gem-moment', storyfirstVariants],
  story: ['gem-story', storyfirstVariants],
} satisfies Record<
  ResourceTypes,
  [string, Partial<Record<GlyphVariants, string | Record<Theme, string>>>]
>

const isValidResourceType = (
  resourceType: string
): resourceType is ResourceTypes => {
  return RESOURCE_TYPES.includes(resourceType as ResourceTypes)
}

export const getResourceGlyph = (
  theme: Theme,
  resourceType: string,
  variant: GlyphVariants = 'filled',
  fallbackGlyph = 'gem-file'
): string => {
  if (!isValidResourceType(resourceType)) {
    return fallbackGlyph
  }

  const [baseGlyph, variants] = resourceGlyphMap[resourceType]
  if (variant === 'filled' && variant in variants) {
    return baseGlyph + variants.filled[theme]
  }

  return baseGlyph + variants.outlined
}
